function initialize() {
    $('.header .btn-menu').on('click', function () {
        $('body').toggleClass('is-menu-open');
    });

    $('.header .select-lang .btn-lang').on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var selectLang = $('.header .select-lang');
        selectLang.toggleClass('is-open');

        if (selectLang.hasClass('is-open')) {
            $('body').one('click', function () {
                selectLang.removeClass('is-open');
            });
        }
    });

    $('.header .select-lang .list-lang a').on('click', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        selectLanguage($(this).data('lang'));
    });
}

function selectLanguage(lang) {
    var hrefLang = $('link[data-lang="' + lang + '"]');

    if (hrefLang.length > 0) {
        window.location = hrefLang.attr('href');
    } else if (lang == 'pt_BR') {
        window.location = base_url;
    } else {
        window.location = base_url + lang;
    }
}

initialize();
